import CurrencyItem from "../model/CurrencyItem";
import FormatUtil from "./FormatUtil";

/*************************************
 * 0 USD     => "$0.00"
 * 0.0001 USD => "< $0.01"
 * -0.0001 USD => "> -$0.01"
 * 10 USD    => "$10.00"
 *************************************/
export const getCurrencyString = (currencyItem?: CurrencyItem): string => {
    if (!currencyItem || Number.isNaN(currencyItem.amount)) {
        return "-";
    }
    const minimalValue: number = 0.01;
    var value = currencyItem.amount;
    if (currencyItem.amount < 0 && currencyItem.amount > (0 - minimalValue)) {
        value = 0 - minimalValue;
    }
    if (currencyItem.amount > 0 && currencyItem.amount < minimalValue) {
        value = minimalValue;
    }
    const currencyStr = FormatUtil.formatCurrency(
        currencyItem.currency,
        value,
    );
    if (currencyItem.amount < 0 && currencyItem.amount > (0 - minimalValue)) {
        return "> " + currencyStr;
    }
    if (currencyItem.amount > 0 && currencyItem.amount < minimalValue) {
        return "< " + currencyStr;
    }
    return currencyStr;
}
